import { Component, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { TableStateEnum } from '../../../../../../modules/src/lib/core/components/table/table-state.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ClientQuestionnaireModel,
} from '../../../../../../../../common/dist/angular/models/client-questionnaire.model';
import {
  ClientQuestionnairesApiController,
} from '../../../../../../modules/src/lib/questionnaires/api-controllers/client-questionnaires.api-controller';
import {
  ClientQuestionnaireStatusEnum,
} from '../../../../../../../../common/src/enums/client-questionnaire/client-questionnaire-status.enum';
import {
  ClientQuestionnaireKeynameEnum,
} from '../../../../../../../../common/src/enums/client-questionnaire/client-questionnaire-keyname.enum';
import {
  ClientQuestionnaireStore,
} from '../../../../../../modules/src/lib/questionnaires/stores/client-questionnaire.store';
import { DateUtils } from '../../../../../../modules/src/lib/core/utils/date.utils';
import {
  SearchQuery,
} from '../../../../../../../../server/dist/angular/server/src/microservice/models/search-query.model';
import {
  ClientQuestionnaireIndexModel,
} from '../../../../../../../../common/src/index-models/client-questionnaire.index-model';
import { SearchResult } from '../../../../../../../../common/src/models/search-result.model';
import {
  SearchQueryField,
} from '../../../../../../../../server/dist/angular/server/src/microservice/models/search-query-field.model';
import { SortOrderEnum } from '../../../../../../../../server/dist/angular/server/src/indexing/enums/sort-order.enum';

@Component({
  selector: 'app-client-questionnaire-list-table',
  templateUrl: './client-questionnaire-list-table.component.html',
  styleUrls: ['./client-questionnaire-list-table.component.scss'],
  standalone: false,
})
export class ClientQuestionnaireListTableComponent implements OnInit {

  isLoading = false;

  showHasBeenRefreshed = false;

  searchResult?: SearchResult<ClientQuestionnaireIndexModel>;

  searchQuery = new SearchQuery();

  columns: { displayText: string, keyname: string, isSortable: boolean }[] = [
    { displayText: 'Nom du client', keyname: 'clientName', isSortable: true },
    { displayText: 'Questionnaire', keyname: 'keyname', isSortable: false },
    { displayText: 'Statut', keyname: 'status', isSortable: false },
    { displayText: 'Dernière modification', keyname: 'updatedAt', isSortable: false },
    { displayText: 'Actions', keyname: 'actions', isSortable: false },
  ];

  tableState: TableStateEnum = TableStateEnum.Loading;

  TableStateEnum = TableStateEnum;

  constructor(public readonly authService: AuthService,
              private readonly clientQuestionnairesApiController: ClientQuestionnairesApiController,
              public readonly router: Router,
              public readonly route: ActivatedRoute,
              private readonly clientQuestionnaireStore: ClientQuestionnaireStore,
              private readonly modalService: NgbModal,
              private readonly dateUtils: DateUtils,
  ) {
  }

  async ngOnInit() {
    this.searchQuery.fields.push(new SearchQueryField('updatedAt', {
      field: 'updatedAt',
      order: SortOrderEnum.Descending,
    }));
    // this.searchQuery.setSort("updatedAt", "desc");
    await this.refresh();
  }

  async refresh() {
    if (this.searchResult === undefined) {
      this.tableState = TableStateEnum.Loading;
    } else {
      this.tableState = TableStateEnum.Refreshing;
    }

    this.searchResult = await this.clientQuestionnairesApiController.search(this.searchQuery);
    if (this.searchResult.totalNumberOfResults === 0) {
      this.tableState = TableStateEnum.NoData;
    } else {
      this.tableState = TableStateEnum.Loaded;
    }

  }

  getResults(): ClientQuestionnaireIndexModel[] {
    if (this.searchResult === undefined) {
      return [];
    }

    return this.searchResult.results;
  }

  async clientQuestionnaireClicked(clientQuestionnaireModel: ClientQuestionnaireIndexModel) {
    return await this.router.navigate([clientQuestionnaireModel.keyname, clientQuestionnaireModel.id], { relativeTo: this.route });
  }

  getStatusText(status: ClientQuestionnaireStatusEnum) {
    switch (status) {
      case ClientQuestionnaireStatusEnum.Created:
        return 'Créé';

      case ClientQuestionnaireStatusEnum.InProgress:
        return 'En cours d\'exécution';

      case ClientQuestionnaireStatusEnum.Finalized:
        return 'Terminé';
    }

    return 'En cours de chargement...';
  }

  getKeynameText(keyname: ClientQuestionnaireKeynameEnum) {
    switch (keyname) {
      case ClientQuestionnaireKeynameEnum.QuebecTaxForm2023:
        return 'Canada + Québec 2023';
      case ClientQuestionnaireKeynameEnum.QuebecTaxForm2022:
        return 'Canada + Québec 2022';
    }
    return 'Défault';
  }

  getLastModifiedText(model: ClientQuestionnaireModel | ClientQuestionnaireIndexModel) {
    return this.dateUtils.getLastModifiedText(model.updatedAt);
  }

}
